import { useQuery } from '@tanstack/react-query';

import { checkBookingStatus } from '../../api/bookingService/requests';
import { queryRetry } from '../query-retry';

export const useCheckBookingStatus = (bookingRecordId: string | null) => {
    const REFETCH_INTERVAL_MS = 3000;

    const hasParamsBookingRecordId = bookingRecordId !== null && bookingRecordId.length > 0;

    const query = useQuery({
        enabled: hasParamsBookingRecordId,
        queryFn: () => checkBookingStatus(bookingRecordId as string),
        queryKey: ['booking', 'status'],
        refetchInterval: REFETCH_INTERVAL_MS,
        retry: queryRetry,
    });

    return {
        query,
    };
};
